import {
  MONTH_SUMMARY_ALL,
  MONTH_SUMMARY_GET,
  MONTH_SUMMARY_PUT,
  MONTH_SUMMARY_POST,
  MONTH_SUMMARY_LOADING,
  MONTH_SUMMARY_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const MonthSumCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: MONTH_SUMMARY_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/month-summary`,
      {
        ...payload,
      },
    );
    dispatch({ type: MONTH_SUMMARY_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: MONTH_SUMMARY_ERROR });
    throw new Error(error);
  }
};

export const MonthSumAll =
  (params = {}) =>
  async (dispatch) => {
    try {
      const { name = '', size = null, page = 1 } = params;
      const { data, status } = await api.get(
        `${process.env.REACT_APP_API_URL}/month-summary`,
      );
      if (status === 200) {
        dispatch({ type: MONTH_SUMMARY_ALL, payload: data });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: MONTH_SUMMARY_ERROR });
      throw new Error(error);
    }
  };

export const MonthSumGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/month-summary/${id}`,
    );
    if (status === 200) {
      dispatch({ type: MONTH_SUMMARY_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: MONTH_SUMMARY_ERROR });
    throw new Error(error);
  }
};

export const MonthSumPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: MONTH_SUMMARY_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/month-summary/${id}`,
      payload,
    );
    dispatch({ type: MONTH_SUMMARY_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: MONTH_SUMMARY_ERROR });
    throw new Error(error);
  }
};
